import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewTransactionListingComponent } from '../new-transaction-listing/new-transaction-listing.component';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { GoogleReviewModalComponent } from '../google-review-modal/google-review-modal.component';
import { FormControl, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-new-sub-admins',
  templateUrl: './new-sub-admins.component.html',
  styleUrls: ['./new-sub-admins.component.scss'],
})
export class NewSubAdminsComponent implements OnInit {
  subadmins: any;
  year = moment().year();
  currentYear = moment().year();
  years: { id: string; name: string }[];
  search: any;
  google_feedbacks: any;
  edit_google_review: any;
  editFG: FormGroup;
  edit_google_feedbacks: any;
  url_names: any;
  private modalRef;
  delete_user_id: any;
  enteredPass: any;
  superAdminCode = '0801';
  user_login_history_list: any;
  user_login_history_list_length: any;

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private modalService: NgbModal,
    private local: LocalServiceService
  ) {}

  ngOnInit(): void {
    this.new_all_sub_admins_list(this.year);
    this.get_all_url_names();
    this.yearsData();
    this.get_feedback_subadmin_google();

    this.editFG = new FormGroup({
      feedbackNameId: new FormControl(''), // add default value
      description: new FormControl(''),
      star: new FormControl(''),
    });
  }

  open_google_review_modal() {
    this.modalService.open(GoogleReviewModalComponent, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'v2_login_model',
    });
  }

  lockopen(id,setvalue) {
    let formData = new FormData();
    formData.append('id', id);
    formData.append('par', setvalue);

    this.auth.set_sub_admin_lock(formData).subscribe(
      (response: any) => {
       // response.body.map((e) => (e.dataLength = e.data.length));
        if (response.body == 1) {
          this.new_all_sub_admins_list(this.year);
        }
        //this.subadmins = response.body;
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }
  new_all_sub_admins_list(year) {
    let formData = new FormData();
    formData.append('year', year.toString());

    this.auth.new_all_sub_admins_list(formData).subscribe(
      (response: any) => {
        response.body.map((e) => (e.dataLength = e.data.length));

        this.subadmins = response.body;
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  yearsData() {
    this.years = [
      { id: '1', name: '2020' },
      { id: '2', name: '2021' },
      { id: '3', name: '2022' },
      { id: '4', name: '2023' },
      { id: '5', name: '2024' },
      { id: '6', name: '2025' },
      { id: '7', name: '2026' },
      { id: '8', name: '2027' },
      { id: '9', name: '2028' },
      { id: '10', name: '2029' },
      { id: '11', name: '2030' },
    ];
  }

  onChangeYear(event) {
    console.log(event.target.value);

    this.new_all_sub_admins_list(event.target.value);
  }

  edit_profile_details(id) {
    this.router.navigate([`/admin/update-profile/${id}`]);
  }

  open_transaction_listing(id) {
    const transactionModal = this.modalService.open(
      NewTransactionListingComponent,
      { size: 'sm', ariaLabelledBy: 'modal-basic-title' }
    );
    transactionModal.componentInstance.transactionId = id;
  }

  get_feedback_subadmin_google() {
    this.auth.get_feedback_subadmin_google(0).subscribe(
      (response: any) => {
        this.google_feedbacks = response.body;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  editReview(content, id) {
    // // console.log('============hereeeeeee',id)
    // return
    this.edit_google_review = id;
    this.auth.edit_feedback_subadmin_google(id).subscribe(
      (response: any) => {
        this.edit_google_feedbacks = response.body;

        this.modalService.open(content, {
          backdropClass: 'light-blue-backdrop',
        });
        this.editFG.patchValue({
          feedbackNameId: this.edit_google_feedbacks.feedbackNameId, // add default value
          description: this.edit_google_feedbacks.description,
          star: this.edit_google_feedbacks.star,
        });
        // const fillData = this.modalService.open(GoogleReviewModalComponent, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'v2_login_model' })
        // fillData.componentInstance.edit_review_data = this.edit_google_feedbacks;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  get_all_url_names() {
    let formData = new FormData();
    formData.append('urlName', '');

    this.auth.get_feedback_url_name(formData).subscribe(
      (response: any) => {
        this.url_names = response.body.names;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }
  update_edit_google_feedbacks() {
    this.auth
      .update_edit_google_feedbacks(this.editFG.value, this.edit_google_review)
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }

  verify_review(id) {
    this.auth.verify_feedback_subadmin_google(id).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.ngOnInit();
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  block_unblock_user(id) {
    let formData = new FormData();
    formData.append('userId', id);

    this.auth.block_unblock_user(formData).subscribe(
      (response: any) => {
        this.new_all_sub_admins_list(this.year);
        this.toastr.success(response.message);
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  get_user_login_history(id) {
    let formData = new FormData();
    formData.append('userId', id);

    this.auth.user_login_history(formData).subscribe(
      (response: any) => {
        console.log(response.body)
        this.user_login_history_list = response.body;
        this.user_login_history_list_length = response.body.length
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  onOtpChange(event) { this.enteredPass = event; }

  onDeleteData() {
    if (this.enteredPass == undefined || this.enteredPass == '') {
      this.toastr.error('Please enter correct password')
      return;
    }
    ((this.enteredPass) === this.superAdminCode) ? this.deleteUser(this.delete_user_id) : this.toastr.error('Password is incorrect');

  }

  delete_user(modal:any, user_id) {
    this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title' });
    this.delete_user_id = user_id;
  }

  login_history(modal:any, user_id) {
    this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title' });
    this.get_user_login_history(user_id);
  }

  deleteUser(id) {
    let formData = new FormData();
    formData.append('userId', id);

    this.auth.deleteUser(formData).subscribe(
      (response: any) => {
        this.new_all_sub_admins_list(this.year);
        this.modalService.dismissAll();
        this.toastr.success(response.message);
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }
}
